export default "__VITE_ASSET__DSawVquS__"